import { z } from 'zod';

export const HealthbridgeTokenSchema = z.object({
  error: z.string().optional(),
  access_token: z.string(),
  token_type: z.string(),
  expires_in: z.number(),
  ext_expires_in: z.number(),
});

export type HealthbridgeToken = z.infer<typeof HealthbridgeTokenSchema>;

export interface OAuth2Credentials {
  client_id: string;
  client_secret: string;
  scope: string;
  grant_type: string;
}
